import { GridViewWebComponent } from '../../../grid/gridView';
import { GridEntry } from "./phasr-recommendations-grid-entry";
import { GzSideMenuWebComponent } from "../../../ui/gzSideMenu";

export enum Column {
  RECOMMENDATION_NAME = 0,
  ATTACK_SURFACE_EXPOSURE = 1,
  CREATED_ON = 2,
  DESCRIPTION = 3,
  PHASR_CATEGORIES = 4,
  COMPANY = 5,
  SELECT = 6,
  MONITORED_RULE = 7,
  BEHAVIORAL_PROFILES = 8,
  ACTION_TAKEN = 9,
  BEHAVIORAL_PROFILE_IDENTITIES = 10,
  BEHAVIORAL_PROFILE_RESOURCES = 11,
}

export enum ColumnKeys {
  RECOMMENDATION_NAME = 'ruleId',
  ATTACK_SURFACE_EXPOSURE = 'attackSurfaceReduction',
  CREATED_ON = 'createdOn',
  DESCRIPTION = 'ruleIdDescription',
  PHASR_CATEGORIES = 'categoryId',
  COMPANY = 'company',
  SELECT = 'select',
  MONITORED_RULE = 'ruleIdRule',
  BEHAVIORAL_PROFILES = 'behavioralProfiles',
  ACTION_TAKEN = 'actionTaken',
  BEHAVIORAL_PROFILE_IDENTITIES = 'behavioralProfileIdentities',
  BEHAVIORAL_PROFILE_RESOURCES = 'behavioralProfileResources',
}

export enum PhasrRecommendationsGridEvents {
  OnRecommendationAllowAccess = 'OnRecommendationAllowAccess',
  OnRecommendationRestrictAccess = 'OnRecommendationRestrictAccess',
}

export interface DomSchema {
  $wrapper: HTMLElement;
  $grid: GridViewWebComponent<Column, ColumnKeys, GridEntry>;
  $title: HTMLElement;
  $hostElement: HTMLElement;
  $detailsPanel: GzSideMenuWebComponent;
  $behavioralProfilesPanel: GzSideMenuWebComponent;
}
